import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { CustomformComponent } from '../../../customform/customform.component';

export interface IPageComponentCustomformData extends NICmsContentComponent.IData {
    form_identifier?: string;
    newsletter_source?: string;
    show_brochure_checkbox?: boolean;
}

/**
 * Customform component.
 *
 * @usage
 *
 * ## Normal
 * `PageComponentCustomformModule` must be added to `CatalogModule` `imports`.
 *
 * ```html
 * <page-component-customform [component]="component"></page-component-customform>
 * ```
 *
 * @input component
 */
@Component({
    selector: 'page-component-customform',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: ` <customform
        class="block"
        [ngStyle]="{ minHeight: client.isCms ? '50px' : 'unset' }"
        [identifier]="component?.form_identifier"
        [source]="component?.newsletter_source"
        [showBrochureCheckbox]="component?.show_brochure_checkbox"
    ></customform>`,
    standalone: true,
    imports: [CustomformComponent, NgStyle]
})
@ICmsComponent<PageComponentCustomformComponent>({
    id: 'customform',
    name: 'Custom Form',
    description: 'Custom form from Landofcoders Magento plugin',
    tags: ['form', 'custom'],
    isAdvanced: true,
    fields: [
        {
            key: 'form_identifier',
            type: NICmsContentField.EFieldType.text,
            title: 'Form Identifier'
        },
        {
            key: 'newsletter_source',
            type: NICmsContentField.EFieldType.text,
            title: 'Newsletter Source'
        },
        {
            key: 'show_brochure_checkbox',
            type: NICmsContentField.EFieldType.checkbox,
            title: 'Show Brochure Checkbox',
            default: false
        }
    ]
})
export class PageComponentCustomformComponent extends UiComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: IPageComponentCustomformData;

    override ngOnInit(): void {
        super.ngOnInit();
        this.subscriptions.add(this.client.isCms$.subscribe(() => this.onBreakpoint()));
    }
}
